import { CreateGroup } from "@components/groups/create-group";
import { ViewModeSelector } from "@components/view-mode-selector/view-mode-selector";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** List of all the available groups in the company */
  groups: FaroCoreApiTypes.GroupSummaryResponse[];
}

/**
 * The action buttons to be shown in the groups page
 */
export function GroupsActionButtons({ groups }: Props): JSX.Element {
  const { canCreateGroups } = useHasUserValidRoleCompanyLevel();

  return (
    <>
      <ViewModeSelector subject="groups" />
      {canCreateGroups && <CreateGroup groups={groups} />}
    </>
  );
}
